module.exports = __webpack_public_path__ + "static/media/home-img-mob.f5177f69.jpg";